import { FunctionComponent } from "react";

import {
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { ServerMigrationResponse } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { ServerMigrationFooter } from "./ServerMigrationFooter";
import { ServerMigrationOverview } from "./ServerMigrationOverview";
import { ServerMigrationSteps } from "./ServerMigrationSteps";

interface ServerMigrationResultStageProps {
  migration: ServerMigrationResponse;
  onClose: () => void;
}

export const ServerMigrationResultStage: FunctionComponent<ServerMigrationResultStageProps> = ({
  migration,
  onClose
}) => {
  const theme = useTheme();

  return (
    <>
      <Stack tokens={{ childrenGap: theme.spacing.m }}>
        {migration.success ? (
          <MessageBar messageBarType={MessageBarType.success}>
            Server migration completed
            {migration.elapsedTime ? ` in ${migration.elapsedTime}` : ""}.
          </MessageBar>
        ) : (
          <MessageBar messageBarType={MessageBarType.error}>
            Server migration did not complete successfully. Review the steps
            below.
          </MessageBar>
        )}
        <ServerMigrationOverview response={migration} />
        <ServerMigrationSteps title="Migration" steps={migration.steps} />
        <Text variant="small">Correlation id: {migration.correlationId}</Text>
      </Stack>
      <ServerMigrationFooter>
        <PrimaryButton text="Close" onClick={onClose} />
      </ServerMigrationFooter>
    </>
  );
};
